import type { SVGProps } from 'react';

const SvgRankingCharThreeTrophy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={72}
    viewBox='0 0 72 72'
    width={72}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0 36C0 16.118 16.118 0 36 0s36 16.118 36 36-16.118 36-36 36S0 55.882 0 36'
      fill='#F3F3F3'
    />
    <path
      d='M43.966 17.47a19.1 19.1 0 0 1 5.325 4.724c1.642 2.138 2.722 4.523 3.292 7.148.45 2.07.57 4.155.315 6.255-.142 1.177-.39 2.325-.802 3.435-3.21-.795-6.413-1.605-9.63-2.37-.878-.21-1.733-.533-2.648-.555-.675-.015-1.192.397-1.275.982-.112.795.158 1.223.923 1.455.18.053.36.128.54.188-.173.367-.113.802-.323 1.162-.78-.187-1.545-.405-2.347-.502-1.005-.12-1.8.285-2.19 1.222a6.3 6.3 0 0 0-.473 2.085c-.187 3.465 2.025 6.09 5.123 7.035.202.353.487.645.63 1.035-1.035.128-2.033.458-3.06.623-8.415 1.312-16.673-3.33-19.92-11.213-.668-1.627-1.05-3.315-1.305-5.04a12.7 12.7 0 0 1-.083-3.105c.293-3.12 1.223-6.052 2.963-8.7 1.515-2.31 3.457-4.185 5.797-5.655.083-.052.158-.127.24-.195.518-.135.923-.487 1.395-.697 2.993-1.335 6.098-1.988 9.39-1.733 1.785.143 3.51.518 5.19 1.103 1.02.352 1.98.855 2.94 1.335z'
      fill='#DAB084'
    />
    <path
      d='M40.659 29.498a3.17 3.17 0 0 1-.575 1.812c-.519.72-1.264.738-1.811.049-.818-1.025-.818-3.221-.006-4.246.547-.683 1.287-.665 1.817.049.376.506.586 1.293.575 2.33zM28.66 29.181c.005-.667.12-1.303.453-1.86.557-.937 1.53-.955 2.044.012.661 1.236.672 2.534.016 3.782-.508.967-1.393.991-2 .104-.41-.606-.514-1.304-.514-2.038'
      fill='#000'
    />
    <path
      d='M39.684 39.887c.21-.36.15-.795.322-1.163 1.605.39 3.21.773 4.807 1.17 2.123.525 4.246 1.058 6.368 1.59.6.15 1.238.195 1.77.555-.075.368-.142.728-.218 1.095-.292.653-.48 1.328-.487 2.04-.18.075-.157.255-.203.398a16.3 16.3 0 0 1-1.65 3.6c-.202.322-.502.577-.622.945-.608.6-1.208 1.2-1.815 1.8-.742.322-1.463.69-2.265.87-.293.067-.585-.075-.855.075-.795-.008-1.545-.248-2.31-.428-.78-.472-1.5-1.02-2.108-1.695-.135-.39-.427-.682-.63-1.035l-.72-2.4c-.202-1.897-.172-3.78.188-5.655.218-.577.322-1.177.42-1.777z'
      fill='#B08961'
    />
    <path
      d='M52.958 42.047c-.532-.36-1.17-.405-1.77-.555q-3.184-.801-6.367-1.59c-1.605-.398-3.21-.78-4.808-1.17-.18-.06-.36-.135-.54-.188-.765-.232-1.035-.66-.922-1.455.082-.585.592-.997 1.275-.982.915.022 1.77.345 2.647.555 3.218.765 6.42 1.575 9.63 2.37.593.285 1.26.307 1.875.532.803.293 1.2.908.983 1.688-.21.757-.765 1.042-1.643.84-.112-.03-.24-.03-.36-.038z'
      fill='#956C48'
    />
    <path
      d='M46.171 58.322c.315.097.638.172.938.292.555.218.697.533.555 1.11-.075.3-.15.608-.233.908-.172.667-.457.84-1.155.682q-1.17-.26-2.34-.532-3.204-.765-6.42-1.53c-.885-.21-1.087-.548-.877-1.425.022-.083.037-.173.06-.255.315-1.283.517-1.395 1.83-1.058.067.015.135.015.21.023 1.312.457 2.685.705 4.027 1.042 1.125.278 2.265.495 3.405.743'
      fill='#B08961'
    />
    <path
      d='M52.261 45.19c0-.72.195-1.396.487-2.04.526.194 1.043.404 1.576.584.345.12.705.188 1.057.308.915.307 1.358 1.042 1.222 1.987-.57 4.103-4.395 6.81-8.437 5.985-.067-.015-.127-.052-.187-.075.607-.6 1.207-1.2 1.815-1.8 2.572-.022 4.132-1.77 4.702-3.72.112-.39 0-.592-.375-.697-.623-.173-1.238-.353-1.852-.525z'
      fill='#895E33'
    />
    <path
      d='M46.17 58.322c-1.132-.248-2.272-.465-3.404-.743-1.343-.337-2.715-.585-4.028-1.042.488-1.08.773-1.238 1.928-1.065.42.067.66-.165.847-.473.383-.585.638-1.23.81-1.905.06-.217.135-.427.203-.645.765.18 1.515.42 2.31.428-.135.682-.293 1.365-.398 2.047-.142.938.105 1.343.953 1.77.66.338.87.915.78 1.62z'
      fill='#956C48'
    />
    <path
      d='m39.076 47.327.72 2.4c-3.098-.945-5.31-3.57-5.123-7.035.038-.72.195-1.418.473-2.085.39-.93 1.185-1.343 2.19-1.223.802.098 1.567.315 2.347.503-.097.6-.202 1.207-.42 1.777-.502-.135-1.005-.292-1.507-.405-.608-.135-.848.03-.998.608a4.95 4.95 0 0 0-.097 2.272c.292 1.448 1.05 2.55 2.415 3.188'
      fill='#895E33'
    />
    <path
      d='M39.076 47.327c-1.365-.638-2.122-1.74-2.415-3.188-.157-.765-.105-1.522.098-2.272.15-.578.39-.735.997-.608.51.113 1.005.27 1.508.405-.36 1.875-.383 3.765-.188 5.655z'
      fill='#DAB084'
    />
  </svg>
);
export default SvgRankingCharThreeTrophy;
